import React from "react";
import { useTranslation } from "./hooks/useTranslation";
export const LoadingScreen = ({ message, }) => {
    const t = useTranslation();
    return (React.createElement("div", { className: "loading-screen" },
        React.createElement("div", { className: "icon" },
            React.createElement("div", { className: "lds-default" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null))),
        React.createElement("div", { className: "text" }, message || `${t("Loading")}...`)));
};
